/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isProjectSchema(data: any): boolean {
  return data && data.componentsTree;
}
